import React, { useState, forwardRef, useImperativeHandle } from "react";
import { toast } from "react-toastify";
import { ModalWrapper } from "../../../../components/ModalWrapper";
import { deleteEmployee } from "../services/userService";
import { notifyError, notifySuccess } from "../../../../../assets/toastService";
import CommonButtons from "src/shared/components/CommonButtons";

export interface DeleteConfirmationHandle {
  openModal: (id: string | number, username: string) => void;
}

const DeleteConfirmation = forwardRef<DeleteConfirmationHandle>((_, ref) => {
  const [deletePress, setDeletePress] = useState(false);
  const [tempId, setTempId] = useState<string | number>("");
  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(false);

  useImperativeHandle(ref, () => ({
    openModal: (id: string | number, name: string) => {
      setTempId(id);
      setUsername(name);
      setDeletePress(true);
    },
  }));

  const handleDelete = async () => {
    try {
      setLoading(true);
      await deleteEmployee(tempId);
      notifySuccess("User deleted successfully");
      setTimeout(() => {
        
        setDeletePress(false);
      }, 2000);
    } catch (err) {
      notifyError("Failed to delete user");
    } finally {
      setLoading(false);
      window.location.reload();
    }
  };

  if (!deletePress) return null;

  return (
    <ModalWrapper width="max-w-xl" title="Delete Confirmation" onClose={() => setDeletePress(false)} onBack={() => setDeletePress(false)} showCloseButton={true}>
      <div className="flex justify-center gap-2 mb-4">
        <p className="font-medium text-black">User name:</p>
        <p className="text-black">{username}</p>
      </div>

      <p className="text-black text-center mb-6">Are you sure you want to delete this user?</p>

      <div className="flex justify-center gap-3">
        <CommonButtons className="w-36 h-10" label="Cancel" variant="outlineDanger" onClick={() => setDeletePress(false)} disabled={loading} />
        <CommonButtons className="w-36 h-10" label={loading ? "Deleting..." : "Delete"}  onClick={handleDelete} disabled={loading} />
      </div>
    </ModalWrapper>
  );
});

export default DeleteConfirmation;
